import { AppFeature, SubGroup } from ".";

export class Organization {
    orgId: number;
    orgName: string;
    sourceKey: string;
    isActive: boolean;
    constructionStatusId: number;
}

export class Community extends Organization {
    marketId: number;
    financialStatusId: number;
    constructionStatusId: number;
    poStatusId: number;
    purchasingStatusId: number;
    warrantyCommunityNumber: string;
    city: string;
    state: string;
    zip: string;
    lotContactIds: number[];
    subGroups: SubGroup[];
    subGroupIdsString: string;
    plans: any[];
    jobs: any[];
    accountingUnits: any[];
    displayText: string;
    market: Market;
}

export class Market extends Organization {
    constructionStatusId: number;
    constructionStatusChanged: boolean;
    appFeatures: AppFeature[];
}